import { Controller } from "@hotwired/stimulus"
import { Loggable } from "./concerns/loggable"
import { ShowHide } from "./concerns/showHide"


export default class extends Controller {
  static targets = [ "toggler", "form", "input", "applyButton", "checkoutButtonsContainer" ]

  static values = {
    activeCoupon: String,
  }

  initialize() {
    Loggable(this, {debug: true})
    ShowHide(this)
  }

  connect(){
    if ( this.activeCouponValue !== "" ) {
      this.showForm()
    }
    this.toggleCheckout()
    this.toggleApplyButton()
  }

  showForm(event){
    if (event) {
      event.preventDefault();
    }
    this.hide(this.togglerTarget)
    this.show(this.formTarget)
  }

  toggleCheckout(){
    if (this.isPendingCouponApply()){
      this.hide(this.checkoutButtonsContainerTarget)
    } else {
      this.show(this.checkoutButtonsContainerTarget)
    }
  }

  toggleApplyButton(){
    if (this.isPendingCouponApply()){
      this.show(this.applyButtonTarget)
    } else {
      this.hide(this.applyButtonTarget)
    }
  }

  isPendingCouponApply(){
    return this.inputTarget.value !== this.activeCouponValue
  }

}
